import { Component, computed, input, model, output } from '@angular/core';

import { InfoCardTitleComponent } from './components/info-card-title/info-card-title.component';
import { InfoCardType } from '../../../model/info-card-type.enum';

@Component({
  selector: 'lib-ikp-info-card',
  standalone: true,
  imports: [InfoCardTitleComponent],
  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.scss',
})
export class InfoCardComponent {
  readonly infoCardType = input<InfoCardType>();
  readonly title = input<string>();
  readonly subtitle = input<string>();
  readonly iconPath = input<string>();
  readonly isCheckbox = input<boolean>();
  readonly isChecked = input<boolean>();
  readonly actionText = input<string>();
  readonly actionColor = input('dark-blue');
  readonly actionIcon = input<string>();
  readonly actionClicked = output<void>();
  readonly showContent = input<boolean>(true);
  isCollapsed = model<boolean>();
  index = input<number>();
  dataTestPrefix = input<string>('');
  dataTestAttribute = computed(() => {
    const prefix = this.dataTestPrefix() ? `${this.dataTestPrefix()}-` : '';
    const attribute = this.index() || this.index() === 0 ? 'infoCardTitle-' + this.index() : 'infoCardTitle';
    return prefix + attribute;
  });

  onActionClicked() {
    this.actionClicked.emit();
  }
}
